var map = {
	"./GE_Digital.png": 23,
	"./Penaltykicks.gif": 24,
	"./SHMS.png": 22,
	"./UF.jpeg": 20,
	"./airbnbLogo.png": 89,
	"./codeInLogo.webp": 90,
	"./contactMail.webp": 91,
	"./contactMailDark.svg": 92,
	"./developerActivity.svg": 93,
	"./facebookLogo.png": 94,
	"./googleAssistant.svg": 95,
	"./googleAssistantLogo.webp": 96,
	"./harvardLogo.png": 97,
	"./jsFramework.svg": 98,
	"./laptop.gif": 26,
	"./manOnTable.svg": 99,
	"./man_coding.jpg": 27,
	"./nextuLogo.webp": 100,
	"./programmer.svg": 101,
	"./pwa.webp": 102,
	"./pwaLogo.webp": 103,
	"./quoraLogo.png": 104,
	"./saayaHealthLogo.webp": 105,
	"./skill.svg": 28,
	"./stanfordLogo.png": 106,
	"./talksCardBack.svg": 107,
	"./talksCardBackAlt.svg": 108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88;